import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "dashboard-card" }
const _hoisted_2 = { class: "dashboard-link" }
const _hoisted_3 = { class: "link-container" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "qr-section" }
const _hoisted_6 = {
  key: 1,
  style: {"color":"var(--el-color-primary)"}
}

import { ref } from 'vue';
import { copyText } from "@/utils/index";

// 定义 props 来接收外部传入的值

export default /*@__PURE__*/_defineComponent({
  __name: 'inviteCard',
  props: {
    dashboardLink: {},
    imgSrc: {},
    overTime: {}
  },
  setup(__props: any) {

const props = __props;

const dashboardLink = ref(props.dashboardLink);

function copyLink() {
  let url = `万川AI新媒体平台，AI 赋能制造企业。优化销售、升级管理、革新生产。[ ${dashboardLink.value} ]`
  copyText(url)
}



return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "dashboard-title" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "万川AI",
        class: "dashboard-icon"
      }),
      _createTextVNode(" 颠覆想象！万川 AI 平台，开启智能新纪元 ")
    ], -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", null, "你是否在寻觅一个能够引领行业变革的创新平台？万川 AI 平台震撼来袭！专注于以 AI 科技激活各行各业潜能，让企业以最小投入赢取最大效益回报。我们始终站在技术创新前沿，深度探索大型人工智能模型的实际应用。通过\"万川 AI 新媒体\"和\"万川 AI 平台\"解决方案，高效融合前沿技术于制造企业的销售策略、运营管理及生产流程中。在这里，你将开启一段充满惊喜与机遇的智能之旅，释放无限潜能，共创辉煌未来。", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"12px","margin-bottom":"10px","color":"#4f4f4fab"} }, "独家专属邀请链接", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "text",
          value: dashboardLink.value,
          readonly: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("button", { onClick: copyLink }, [
          _createVNode(_component_svgIcon, {
            iconClass: "file-copy-2-fill",
            width: "0.8vw",
            height: "0.8vw"
          }),
          _cache[0] || (_cache[0] = _createTextVNode(" 一键复制 "))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "divider" }, [
        _createElementVNode("span", { style: {"margin":"0 5px"} }, "微信扫码，轻松踏上奇妙征程")
      ], -1)),
      (_ctx.imgSrc)
        ? (_openBlock(), _createBlock(_component_vue_qrcode, {
            key: 0,
            value: dashboardLink.value
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_ctx.overTime)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "有效期限：" + _toDisplayString(_ctx.overTime), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})